import { render } from "./PrinterCamera.vue?vue&type=template&id=0c541a81"
import script from "./PrinterCamera.vue?vue&type=script&lang=js"
export * from "./PrinterCamera.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__